import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="mobile-sidebar"
export default class extends Controller {
    static targets = ["sidebar", "overlay"];

    connect() {
        document.addEventListener("turbo:load", () => {
            this.close();
        });
    }

    toggle() {
        const isOpen = !this.sidebarTarget.classList.contains("-translate-x-full");
        isOpen ? this.close() : this.open();
    }

    open() {
        this.sidebarTarget.classList.replace("-translate-x-full", "translate-x-0");
        this.sidebarTarget.classList.remove("pointer-events-none");
        this.overlayTarget.classList.remove("hidden");
    }

    close() {
        this.sidebarTarget.classList.replace("translate-x-0", "-translate-x-full");
        this.sidebarTarget.classList.add("pointer-events-none");
        this.overlayTarget.classList.add("hidden");
    }

    closeFromOverlay() {
        this.close();
    }
}
